<template>
  <v-menu
    offset-y
    :close-on-content-click="!selectedAction"
    :close-on-click="!selectedAction"
    rounded
    :value="shown"
    :key="menuKey"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-tooltip max-width="400" bottom>
        <template v-slot:activator="{ on: onTooltip, attrs: attrsTooltip }">
          <v-btn
            elevation="1"
            fab
            small
            v-bind="{ ...attrs, ...attrsTooltip }"
            v-on="{ ...on, ...onTooltip }"
            :style="{
              'box-shadow': selectedAction
                ? '0 0 10px 3px ' +
                  $vuetify.theme.currentTheme.primary +
                  ' !important'
                : '',
            }"
            class="primary secondary--text ma-1"
            id="actions-multiple"
            :disabled="initLoading"
            @click="shown = true"
          >
            <v-icon> mdi-checkbox-multiple-marked </v-icon>
          </v-btn>
        </template>
        <div width="300">
          {{ $t('massiveAction') }}
        </div>
      </v-tooltip>
    </template>
    <template v-if="!selectedAction">
      <v-list width="300">
        <v-list-item
          v-for="(item, index) in actions"
          :key="'massive-action-' + index + '-' + item.title"
          :value="index"
          :disabled="item.disabled"
          @click="setAction(item)"
        >
          <v-list-item-icon v-if="item.icon">
            <v-icon v-text="item.icon"></v-icon>
          </v-list-item-icon>

          <v-list-item-title
            :style="{
              color:
                item === selectedAction
                  ? $vuetify.theme.currentTheme.primary
                  : '',
            }"
          >
            {{ $t('massiveActions.titles.' + item.title) }}
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </template>
    <v-card v-else>
      <v-card-text>
        <b>{{ $t('massiveActions.titles.' + selectedAction) }}</b> -
        <span v-if="isOpenNotification"
          >{{ items.length }} / {{ maxMassiveActionItems }}
          {{ $t('elements') }}</span
        >
        <span v-else>{{ items.length }} {{ $t('elements') }}</span>
        <div class="my-5" />
        <v-form
          ref="massiveActionForm"
          v-model="validMassiveActionForm"
          lazy-validation
          :loading="loading"
          @submit.prevent="onSubmit"
        >
          <ChangeStatusOptions
            v-if="isChangeStatus"
            @setStatus="(newStatus) => setData(newStatus, 'status')"
          />
          <OperatorsOptions
            v-if="isSetResponsible"
            :operators="operators"
            :groups="groups"
            @setOperator="(op) => setData(op, 'operator')"
            @setGroup="(grp) => setData(grp, 'operator')"
          />
          <AlertOptions
            v-if="isSetAlert"
            @setAlert="(newAlert) => setData(newAlert, 'alert')"
          />
          <ObservationOptions
            v-if="isSetObservation"
            @setObservation="
              (newObservation) => setData(newObservation, 'observation')
            "
          />
        </v-form>
      </v-card-text>
      <v-card-actions class="justify-center">
        <v-btn
          small
          icon
          color="success"
          :disabled="noItemsSelected || loading"
          :loading="loading"
          @click="performAction"
        >
          <v-icon>mdi-check</v-icon>
        </v-btn>
        <v-btn small icon color="error" @click="removeAction">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
import { mapMutations } from 'vuex'
import { mapGetters } from 'vuex'
import ChangeStatusOptions from '@/components/massive-actions/additional-data/ChangeStatusOptions'
import OperatorsOptions from '@/components/massive-actions/additional-data/OperatorsOptions'
import AlertOptions from '@/components/massive-actions/additional-data/AlertOptions'
import ObservationOptions from '@/components/massive-actions/additional-data/ObservationOptions'
import {
  massiveActionChangeStatus,
  massiveDownloadFiles,
} from '@/services/massive-actions-service'
import GraphService from '@/services/graph-service'
import { getNotificationStatusFromI18n } from '@/services/notification-service'
import getErrorText from '../../utils/get-error-text'
import {
  massiveOpenNotification,
  massiveSetAlert,
  massiveSetObservation,
  massiveSetResponsible,
} from '../../services/massive-actions-service'
//import { getUserOperators } from '../../services/operator-service'
import { getUserInfo } from '@/services/user-service'
import { listGroups } from '@/services/groups-service'
import { getFilterAdminFilter } from '../../services/filter-service'
import { checkItem } from '@/utils/massive-actions'
import { downloadMassiveIcs } from '@/services/alert-service'

export default {
  props: {
    actions: Array,
    items: Array,
    objectType: {
      type: String,
      default: 'notifications',
    },
    contextOperators: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    ChangeStatusOptions,
    OperatorsOptions,
    AlertOptions,
    ObservationOptions,
  },
  async mounted() {
    this.initLoading = true

    // Adding the base user
    const user = this.$store.state.user
    user.finalRole = getFilterAdminFilter()

    // Getting other operators
    ////this.operators = [user, ...(await getUserOperators())]

    // Obtener todos los grupos
    this.groups = await listGroups()

    const userId = this.isOperatorUser
      ? this.$store.state.user.parentRef.id
      : this.$store.state.user.id

    this.userParent = await getUserInfo(userId)

    this.initLoading = false
  },
  data() {
    return {
      loading: false,
      initLoading: false,
      validMassiveActionForm: false,
      shown: false,
      selectedAction: undefined,
      selectedOperator: undefined,
      status: undefined,
      operator: undefined,
      alert: undefined,
      observation: undefined,
      //operators: [],
      userParent: undefined,
      groups: [],
      maxMassiveActionItems: 0,
    }
  },
  methods: {
    ...mapMutations(['setSnackbar']),
    /**
     * Sets a selected action.
     * @param {String} action Action selected.
     */
    setAction(action) {
      if (action.disabled) return
      this.selectedAction = action.title
      this.maxMassiveActionItems =
        action.maxMassiveActionItems || this.maxMassiveActionItems
      this.$emit('actionSelected', action.title)
    },
    /**
     * Sets the data of the massive action.
     * @param {Object} data Data to be set.
     * @param {string} key Key to stablish.
     */
    setData(data, key) {
      this[key] = data
      this.$emit('setMassiveActionData', {
        [key]: data,
      })
    },
    /**
     * Removes the selected action.
     */
    removeAction() {
      if (this.selectedAction) {
        this.selectedAction = undefined
        this.$emit('actionSelected', false)
        this.$emit('removeItems', [...Array(this.items.length).keys()])
      }
    },
    /**
     * Performs the massive action
     */
    async performAction() {
      if (!this.$refs.massiveActionForm?.validate()) return

      this.loading = true

      // Calling function to enqueue/perform the tasks
      try {
        const userId = this.isOperatorUser
          ? this.$store.state.user.parentRef.id
          : this.$store.state.user.id

        // control de ausencias en acciones masivas, cuando pueda existir un usuario en modo sustitucion.
        const absentUserId = this.$store.state.user.id

        // Changing status
        if (this.isChangeStatus)
          await massiveActionChangeStatus(
            userId,
            this.items.map((n) => n.id),
            getNotificationStatusFromI18n(this.status),
            absentUserId
          )
        // Openning notifications
        if (this.isOpenNotification)
          await massiveOpenNotification(
            userId,
            this.items.map((n) => n.id),
            absentUserId
          )
        // Setting the responsible
        if (this.isSetResponsible)
          await massiveSetResponsible(
            userId,
            this.operator,
            this.items.map((n) => n.id),
            absentUserId
          )
        // Setting the alert
        if (this.isSetAlert) {
          await massiveSetAlert(
            userId,
            this.alert,
            this.items.map((n) => n.id),
            absentUserId
          )

          if (this.alert.exportToCalendar) {
            downloadMassiveIcs(this.alert, this.items, this.objectType)
          }

          if (this.alert.addToOutlook) {
            try {
              await GraphService.createCalendarEventsBatch(
                this.alert,
                this.items,
                this.objectType
              )
            } catch (calendarError) {
              console.error('Error creating calendar events:', calendarError)
              await this.handleOutlookError(calendarError)
            }
          }
        }
        // Setting the observation
        if (this.isSetObservation)
          await massiveSetObservation(
            userId,
            this.observation,
            this.items.map((n) => n.id),
            absentUserId
          )
        if (this.isDownloadFiles)
          await massiveDownloadFiles(
            userId,
            this.items.map((n) => n.id),
            absentUserId
          )

        let message = this.$t('massiveActions.success.' + this.selectedAction)
        if (this.isDownloadFiles) message = this.$t('exportCompleteZip')

        this.setSnackbar({ position: 'top', type: 'success', message })
        this.removeAction()
        this.shown = false

        this.operator = undefined
        this.alert = undefined
        this.observation = undefined
        this.status = undefined
      } catch (error) {
        const message = getErrorText(error.message)
        this.setSnackbar({
          position: 'top',
          type: 'error',
          message,
        })
      } finally {
        this.loading = false
      }

      this.loading = false
    },
    async handleOutlookError(error) {
      if (
        error.name === 'InteractionRequiredAuthError' ||
        error.errorCode === 'consent_required' ||
        error.errorCode === 'interaction_required' ||
        error.message?.includes('Status: 401')
      ) {
        await this.retryWithInteractiveAuth()
      } else {
        this.setSnackbar({
          position: 'top',
          type: 'error',
          message: this.$t('calendar.outlookEventError'),
        })
      }
    },
    async retryWithInteractiveAuth() {
      try {
        const msalInstance = this.$store.getters.msalInstance
        const loginRequest = {
          scopes: ['User.Read', 'Calendars.ReadWrite'],
          authority: 'https://login.microsoftonline.com/common/v2.0',
        }
        const response = await msalInstance.acquireTokenPopup(loginRequest)

        if (response && response.account) {
          msalInstance.setActiveAccount(response.account)
        }

        // Reintento tras login interactivo
        await GraphService.createCalendarEventsBatch(
          this.alert,
          this.items,
          this.objectType,
          response.accessToken
        )

        this.setSnackbar({
          position: 'top',
          type: 'success',
          message: this.$t('massiveActions.success.' + this.selectedAction),
        })
      } catch (error) {
        console.error('Error in interactive auth:', error)
        this.setSnackbar({
          position: 'top',
          type: 'error',
          message: this.$t('calendar.outlookEventErrorInteractiveFailed'),
        })
      }
    },
  },
  computed: {
    ...mapGetters([
      'isMobile',
      'isOperatorUser',
      'isAdminUser',
      'isEmpresaUser',
    ]),
    noItemsSelected() {
      return this.items.length === 0
    },
    isChangeStatus() {
      return this.selectedAction === 'changeStatus'
    },
    isOpenNotification() {
      return this.selectedAction === 'openNotification'
    },
    isSetResponsible() {
      return this.selectedAction === 'setResponsible'
    },
    isSetAlert() {
      return this.selectedAction === 'setAlert'
    },
    isSetObservation() {
      return this.selectedAction === 'setObservation'
    },
    isDownloadFiles() {
      return this.selectedAction === 'downloadFiles'
    },
    menuKey() {
      return this.selectedAction === 'setResponsible'
        ? 'menu-large'
        : 'menu-normal'
    },
    operators() {
      // contextOperators llega como prop
      /*return this.contextOperators.length
        ? [this.$store.state.user, ...this.contextOperators]
        : [this.$store.state.user]
        */

      const operators = [...this.contextOperators]
      // Insertar en la primera posicion del array el objeto ya leido this.userParent solo en caso de que exista
      if (this.userParent !== undefined) {
        operators.unshift(this.userParent)
      }

      return operators
    },
  },
  watch: {
    contextOperators: {
      async handler(newValue) {
        // Si hay un operador seleccionado recarga su informacion.
        if (this.operator && this.operator.isGroup === false) {
          const updatedOperator = newValue.find(
            (op) => op.id === this.operator.id
          )
          this.operator = { ...updatedOperator, isGroup: this.operator.isGroup }
          if (this.selectedAction === 'setResponsible')
            this.setData(this.operator, 'operator')
        }
      },
    },
    operator: {
      // Ahora operator siempre es un objeto (que contiene un usuario o un grupo), no un string con un id.
      // Ya no hay necesidad de la variable selectedOperator para almacenar el objeto
      immediate: false,
      async handler(newValue) {
        if (!newValue) return

        const itemsToRemove = []
        for (let i = 0; i < this.items.length; i++) {
          const isValid = await checkItem(
            'setResponsible',
            { operator: newValue },
            this.items[i]
          )
          if (!isValid) itemsToRemove.push(i)
        }

        if (itemsToRemove.length) {
          this.$emit('removeItems', itemsToRemove)
        }
      },
    },
    status: async function (newValue) {
      if (!newValue) return

      const itemsToRemove = []
      for (let i = 0; i < this.items.length; i++)
        if (
          !(await checkItem(
            'changeStatus',
            { status: newValue },
            this.items[i]
          ))
        )
          itemsToRemove.push(i)
      this.$emit('removeItems', itemsToRemove)
    },
    /*selectedAction: function (newValue, previousValue) {
      // Elimino este watcher, no es lo que parece:
      // previousValue es un string, por ejemplo "setResponsible", y previousValue.length es 14, la long del string.

      if (newValue !== previousValue && previousValue) {
        const itemsToRemove = [...Array(previousValue.length).keys()]
        this.$emit('removeItems', itemsToRemove)
      }
    },*/
  },
}
</script>
<style lang="scss" scoped>
.menu-normal {
  width: 300px;
  max-height: 600px;
}
.menu-large {
  width: 600px;
  max-height: 600px;
}
</style>
